export function capitalise(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function lowercase(text: string) {
  return text.toLowerCase();
}

export function pluralise(text: string) {
  const lastChar = text.charAt(text.length - 1);
  if (lastChar === "s") {
    return `${text}'`;
  }
  return `${text}'s`;
}

export function joinStrings(
  arr: any[],
  separator: string = ", ",
  finalJoiner: string = "and"
) {
  if (arr.length < 2) return arr.join(separator);
  const front = arr.slice(0, arr.length - 1);
  const back = arr.slice(arr.length - 1);
  return `${front.join(separator)} ${finalJoiner} ${back.join(separator)}`;
}

export function replaceAll(text: string, search: string, replacement: string) {
  return text.split(search).join(replacement);
}

export function buildChangeMessage(changes: object) {
  let message: string = "";
  for (const [key, value] of Object.entries(changes)) {
    message += `${capitalise(key)}: "${value.from}" -> "${value.to}"`;
  }
  return message;
}

export function extractAllStringsBetweenDoubleCurlyBraces(text: string) {
  const regex = /{{([^}]+)}}/g;
  const matches = text.match(regex);
  return matches
    ? matches.map((match) => match.replace("{{", "").replace("}}", ""))
    : [];
}

export function sliceStringAtIndex(text: string, index: number) {
  return text.slice(0, index) + text.slice(index + 1);
}